import './Giants.css';
import { isMapSectionColored } from '../../../../domain';
import { useAppStore } from '../../../store/appStore';
import { mapPaintBoxStyle } from '../lands/landPositions';
import { GIANT_PLACEMENTS } from './giantPositions';
import { MAP_GIANT_IMAGES } from './mapGiantAssets';

/**
 * Map giants in Frame 2 design coords (same world / MAP_SCALE as lands).
 * Color when the giant was ever offered a delivery (sticky unlock).
 */
export function Giants() {
  const playerEconomy = useAppStore((s) => s.playerEconomy);

  return (
    <>
      {GIANT_PLACEMENTS.map((giant) => {
        const imageSrc = MAP_GIANT_IMAGES[giant.id];
        const isColored = isMapSectionColored(playerEconomy, giant.id);

        return (
          <div
            key={giant.id}
            className={[
              'map-giants__giant',
              isColored ? null : 'map-giants__giant--grayscale',
            ]
              .filter(Boolean)
              .join(' ')}
            style={{
              left: giant.left,
              top: giant.top,
              width: giant.width,
              height: giant.height,
            }}
          >
            <div
              className="map-giants__paint"
              style={mapPaintBoxStyle(
                giant.idle.left - giant.left,
                giant.idle.top - giant.top,
                giant.idle.width,
                giant.idle.height,
              )}
            >
              <img
                className="map-giants__img"
                src={imageSrc}
                alt=""
                draggable={false}
              />
            </div>
          </div>
        );
      })}
    </>
  );
}
